import { useNavigate, useParams, useLocation } from "react-router";
import CardsContainer from "../../components/cards/CardsContainer";
import { useExecutionQuery, useExecutionsQuery } from "../../tanstack/hooks/usePlayerQuery";
import useGetSessionId from "../../hooks/useGetSessionId";

function ExecutionPage() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { executionId: activeExecutionId = "" } = useParams();
  const sessionId = useGetSessionId();

  const { data, isError, isLoading } = useExecutionQuery(activeExecutionId, sessionId);
  const { data: executions, refetch } = useExecutionsQuery(sessionId);

  if (isError) {
    navigate("/error");
  }

  if (data?.yantraExecution.status === "CALCULATED") {
    // find next execution
    const nextExecution = executions?.yantraExecutions.find(
      (execution) =>
        execution.yantraId === data.yantraExecution.yantraId &&
        execution.status === "RUNNING",
    );
    if (nextExecution) {
      navigate({ pathname: `/${nextExecution.id}`, search });

      return;
    }

    setTimeout(() => {
      refetch();
    }, 1000);
  }

  return (
    <CardsContainer execution={data?.yantraExecution} isLoading={isLoading} />
  )
}

export default ExecutionPage;
